import { SortBy } from 'tradera/state/services/touchweb-search-api';

export enum QueryType {
    Category = 'Category',
    Search = 'Search',
    Popular = 'Popular',
    Cause = 'Cause'
}

export type ItemListType = {
    id: string;
    queryParams: Record<string, string>;
    queryType: QueryType;
    allowedLanguages: string[];
};
const csaSearch =
    'fjällräven+toteme+rodebjer+odd+molly+adoore+ralph+lauren+patagonia+ganni+arket+Mads+Nørgaard';

const topSearches =
    'svenskt+tenn+zundapp+lego+marimekko+märklin+omega+volvo+saab+puch+fjällräven+louis+vuitton+rolex+toteme+husqvarna+luftgevär+lisa+larson+moped+rodebjer+muminmugg+vintage+retro+pokemon+motorsåg+volvo+240+gustavsberg+seiko+arket+warhammer+gucci+iittala+nintendo+switch+barbie+rörstrand+chanel+volvo+amazon+ganni+odd+molly+taklampa+lampa+ralph+lauren+nikon+guld+amatörradio+festool+makita+dior+iphone';

export const itemQueries: ItemListType[] = [
    // Antique & Design category
    {
        id: 'antiques',
        queryType: QueryType.Category,
        queryParams: {
            categoryId: '20',
            sortBy: SortBy.Relevance,
            fromNumberOfBids: '5',
            toNumberOfBids: '20'
        },
        allowedLanguages: ['sv', 'da', 'de', 'en', 'fr', 'nl']
    },
    //Ended auctions search
    {
        id: 'ended',
        queryType: QueryType.Search,
        queryParams: {
            q: topSearches,
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            itemStatus: 'Ended',
            fromPrice: '300',
            toPrice: '2500'
        },
        allowedLanguages: ['sv', 'da', 'de', 'en', 'fr', 'nl']
    },
    // BIN search
    {
        id: 'bin',
        queryType: QueryType.Search,
        queryParams: {
            q: topSearches,
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            itemType: 'FixedPrice',
            fromPrice: '200',
            fromNumberOfBids: '0',
            toNumberOfBids: '0'
        },
        allowedLanguages: ['sv', 'de', 'en', 'fr', 'nl']
    },
    // Video games category
    {
        id: 'videoGames',
        queryType: QueryType.Category,
        queryParams: {
            categoryId: '30',
            sortBy: SortBy.Relevance,
            fromNumberOfBids: '5',
            toNumberOfBids: '20'
        },
        allowedLanguages: ['sv', 'da', 'de', 'en', 'fr', 'nl']
    },
    // Most popular searches (listnings)
    {
        id: 'popular',
        queryType: QueryType.Popular,
        queryParams: {
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            fromPrice: '100',
            fromWishListCount: '5'
        },
        allowedLanguages: ['sv', 'de', 'en', 'fr', 'nl']
    },
    // CSA search
    {
        id: 'csaSearch',
        queryType: QueryType.Search,
        queryParams: {
            q: csaSearch,
            categoryId: '16',
            queryScope: 'AnyWordsAnyOrder',
            sortBy: SortBy.Relevance,
            fromPrice: '65'
        },
        allowedLanguages: ['sv', 'de', 'en', 'fr', 'nl']
    },
    // Danish hobby
    {
        id: 'danishHobby',
        queryType: QueryType.Search,
        queryParams: {
            q: 'kamera,ure,vinyl,objektiv,armbåndsure,ur,LP,fiskeagn,blink,wobbler,spinnere',
            sortBy: SortBy.Relevance,
            fromPrice: '33'
        },
        allowedLanguages: ['da']
    },
    // Danish hobby
    {
        id: 'danishCollectibles',
        queryType: QueryType.Search,
        queryParams: {
            q: 'kort,bil,bilen,billeder,figur,modelbil,biler,bil',
            sortBy: SortBy.Relevance,
            fromPrice: '33'
        },
        allowedLanguages: ['da']
    }
];

export const getItemQueries = (): ItemListType[] =>
    [...itemQueries].sort(() => 0.5 - Math.random());
